import React from "react";
import { Button, FormCheck } from "react-bootstrap";
import { CheckCircle, Plus } from "react-bootstrap-icons";
import { isAdmin } from "../../helpers/global";
import useAuth from "../../hooks/useAuth";
import DateRangePicker from "../common/DateRangePicker";

const TimeLogActions = ({
  tabs,
  activeTab,
  onTabChange,
  dateRange,
  onDateRangeChange,
  includeDisabledLogs,
  onIncludeDisabledLogsCheckedChange,
  className = "d-flex justify-content-end",
  onAddNewTimeLogClick,
  onApproveSelectedLogClick,
  selectedLogs,
}) => {
  const { user } = useAuth();
  return (
    <div
      className={`${className} d-flex justify-content-between align-items-center w-100`}
    >
      <div
        className="d-flex border align-items-center gap-2"
        style={{ borderRadius: 20 }}
      >
        {tabs?.map(({ label, value, Icon }) => {
          return (
            <div
              size="sm"
              className={`d-flex align-items-center justify-content-center gap-2 py-1 px-2 text-white hover ${
                activeTab === value ? "bg-primary" : "bg-white text-dark"
              }`}
              key={value}
              onClick={() => onTabChange(value)}
              style={{ borderRadius: 20 }}
            >
              {Icon && <Icon />}
              <h6 className="smallFont mb-0"> {label}</h6>
            </div>
          );
        })}
      </div>

      <div className="d-flex justify-content-center align-items-center gap-1">
        {activeTab !== "allTimeLogs" && (
          <>
            <div className="mx-2 d-flex align-items-center">
              <FormCheck
                checked={includeDisabledLogs}
                onChange={() =>
                  onIncludeDisabledLogsCheckedChange(
                    !Boolean(includeDisabledLogs)
                  )
                }
              />
              <h6 className="mb-0 small-text">Include Unapproved Logs</h6>
            </div>
            {activeTab !== "financialDashboard" && (
              <DateRangePicker
                value={dateRange}
                onChange={(ranges) => {
                  onDateRangeChange(ranges);
                }}
                className="m-1"
                allowNavigation
              />
            )}
          </>
        )}
        {activeTab === "allTimeLogs" && (
          <>
            {isAdmin(user?.role) && (
              <Button
                size="sm"
                variant="success"
                className="d-flex align-items-center justify-content-center gap-1 my-1"
                onClick={onApproveSelectedLogClick}
              >
                <CheckCircle /> <h6 className="smallFont mb-0">Approve</h6>
              </Button>
            )}

            <Button
              size="sm"
              variant="dark"
              className="d-flex align-items-center justify-content-center gap-1 my-1"
              onClick={onAddNewTimeLogClick}
            >
              <Plus /> <h6 className="smallFont mb-0">Add new log</h6>
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default TimeLogActions;
